'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import ComponentWithPartials from 'UIComponents/mixins/ComponentWithPartials';
import ModuleCompatibilityTagTypes from 'marketplace-lib/constants/ModuleCompatibilityTagTypes';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import { getMultiselectCheckboxFilterOptions, getMultiselectFilterObjAfterRemove } from '../utils/utils';
import { getMultiselectFilterOptionOrTitleText } from '../utils/langUtils';
export default createReactClass({
  displayName: "MultiselectCheckboxFilter",
  mixins: [ComponentWithPartials, PureRenderMixin],
  propTypes: {
    className: PropTypes.string,
    disableOptions: PropTypes.bool.isRequired,
    filterName: PropTypes.string.isRequired,
    filtersCurrentlyAppliedInComponent: PropTypes.instanceOf(Immutable.List).isRequired,
    onGoodFilterChange: PropTypes.func.isRequired,
    showSelectAll: PropTypes.bool.isRequired,
    trackMultiselectSelection: PropTypes.func.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      disableOptions: false,
      showSelectAll: false
    };
  },
  getFilterOptions: function getFilterOptions() {
    var filterName = this.props.filterName;
    return getMultiselectCheckboxFilterOptions(filterName);
  },
  onFilterOptionChange: function onFilterOptionChange(filterOption, event) {
    var _this$props = this.props,
        filterName = _this$props.filterName,
        currentFilters = _this$props.filtersCurrentlyAppliedInComponent,
        onGoodFilterChange = _this$props.onGoodFilterChange,
        trackMultiselectSelection = _this$props.trackMultiselectSelection;
    var isChecked = event.target.checked;

    if (isChecked) {
      trackMultiselectSelection(filterName, filterOption);
    }

    if (filterName === GoodFiltersAndPage.MODULE_COMPATIBILITY) {
      var filterOptions = Immutable.List(this.getFilterOptions());
      var includesAllCompatibility = currentFilters.includes(ModuleCompatibilityTagTypes.COMPATIBLE_ANY);
      var updatedFilters = Immutable.List([]);

      if (isChecked) {
        if (includesAllCompatibility) {
          updatedFilters = currentFilters.clear().push(filterOption);
        } else {
          updatedFilters = currentFilters.push(filterOption);
        }
      } else {
        if (includesAllCompatibility) {
          updatedFilters = filterOptions.filter(function (opt) {
            return opt !== filterOption;
          });
        } else {
          updatedFilters = currentFilters.filter(function (opt) {
            return opt !== filterOption;
          });
        }
      }

      if (filterOptions.every(function (opt) {
        return updatedFilters.includes(opt);
      })) {
        updatedFilters = updatedFilters.clear().push(ModuleCompatibilityTagTypes.COMPATIBLE_ANY);
      }

      onGoodFilterChange(_defineProperty({}, filterName, updatedFilters));
      return;
    }

    if (isChecked) {
      onGoodFilterChange(_defineProperty({}, filterName, currentFilters.push(filterOption)));
      return;
    }

    onGoodFilterChange(getMultiselectFilterObjAfterRemove(filterName, currentFilters, filterOption));
  },
  onSelectAll: function onSelectAll(event) {
    var _this$props2 = this.props,
        filterName = _this$props2.filterName,
        currentFilters = _this$props2.filtersCurrentlyAppliedInComponent,
        onGoodFilterChange = _this$props2.onGoodFilterChange,
        trackMultiselectSelection = _this$props2.trackMultiselectSelection;
    var isChecked = event.target.checked;
    var filterOptions = filterName === GoodFiltersAndPage.MODULE_COMPATIBILITY ? currentFilters.clear().push([ModuleCompatibilityTagTypes.COMPATIBLE_ANY]) : this.getFilterOptions();
    onGoodFilterChange(_defineProperty({}, filterName, isChecked ? filterOptions : currentFilters.clear()));

    if (isChecked) {
      trackMultiselectSelection(filterName, 'ALL');
    }
  },
  renderCheckboxes: function renderCheckboxes() {
    var _this = this;

    var _this$props3 = this.props,
        disableOptions = _this$props3.disableOptions,
        filterName = _this$props3.filterName,
        currentFilters = _this$props3.filtersCurrentlyAppliedInComponent;
    var filterOptions = this.getFilterOptions();
    var isModuleCompatibility = filterName === GoodFiltersAndPage.MODULE_COMPATIBILITY;
    var includesAllCompatibility = currentFilters.includes(ModuleCompatibilityTagTypes.COMPATIBLE_ANY);
    return filterOptions.map(function (filterOption, index) {
      var checked = currentFilters.includes(filterOption) || isModuleCompatibility && includesAllCompatibility;
      return React.createElement(UICheckbox, {
        checked: checked,
        className: "integrate-" + filterOption,
        "data-test-id": filterName + "-" + filterOption + "-input",
        disabled: disableOptions,
        key: index,
        onChange: _this.partial(_this.onFilterOptionChange, filterOption),
        size: "small"
      }, getMultiselectFilterOptionOrTitleText(filterName, filterOption));
    });
  },
  renderSelectAllCheckbox: function renderSelectAllCheckbox() {
    var _this$props4 = this.props,
        disableOptions = _this$props4.disableOptions,
        filterName = _this$props4.filterName,
        currentFilters = _this$props4.filtersCurrentlyAppliedInComponent,
        showSelectAll = _this$props4.showSelectAll;

    if (!showSelectAll) {
      return null;
    }

    var filterOptions = this.getFilterOptions();
    var allSelected = false;
    var someSelected = false;

    if (filterName === GoodFiltersAndPage.MODULE_COMPATIBILITY) {
      allSelected = currentFilters.includes(ModuleCompatibilityTagTypes.COMPATIBLE_ANY);
    } else {
      allSelected = filterOptions.every(function (val) {
        return currentFilters.includes(val);
      });
      someSelected = !allSelected && currentFilters.size > 0;
    }

    return React.createElement(UICheckbox, {
      checked: allSelected,
      disabled: disableOptions,
      indeterminate: someSelected,
      onChange: this.onSelectAll,
      size: "small"
    }, React.createElement(FormattedMessage, {
      message: "MarketplaceUI.directory.sidebar.multiselectCheckboxFilter.all"
    }));
  },
  render: function render() {
    var _this$props5 = this.props,
        className = _this$props5.className,
        filterName = _this$props5.filterName;
    return React.createElement(UIFormControl, {
      className: className,
      label: getMultiselectFilterOptionOrTitleText(filterName, 'title')
    }, React.createElement(UIToggleGroup, {
      name: filterName
    }, this.renderSelectAllCheckbox(), this.renderCheckboxes()));
  }
});